import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { checkSession, setSessionActive } from '../../Redux/ActionCreator';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import { cookieConst } from '../../shared/BackendCalls/BackendCallsConstants';
import { loginGPMS } from '../../shared/BackendCalls/SharedBackendGets';
import AnalyticsService from '../../shared/Utils/analytics.service';
import { getApiBaseUrl } from '../../shared/Utils/Utils';
import { myGarage, vehicle, signIn } from '../../shared/Constants/SharedConstants';

class LandingGbpe extends React.Component {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
        this.cookieCheck = this.cookieCheck.bind(this);
        this.handleGbpeAuthSuccess = this.handleGbpeAuthSuccess.bind(this);
        this.routeAfterProfile = this.routeAfterProfile.bind(this);
    }

    routeAfterProfile(vehicles) {
        this.props.history.push(vehicles?.length > 0 ? myGarage : vehicle);
    }

    handleGbpeAuthSuccess() {
        const { setSessionActive, checkSession } = this.props;

        loginGPMS(window.gbpe.auth.idToken, (vehicles) => {
            setSessionActive(true);
            checkSession(false);
            this.routeAfterProfile(vehicles);
        });

        if (AnalyticsService().loggingEnabled) {
            AnalyticsService().trackPage('Dealer Flow WebU Sign-in');
        }
    }

    // WebU check code -> If WebU experience handle special flow
    componentDidMount() {
        const { checkSession, history } = this.props;
        checkSession(true);

        if (!window.gbpe) {
            checkSession(false);
            return;
        }

        if (window.gbpe.auth.currentAuthState === 1 && window.gbpe.auth.idToken) {
            this.handleGbpeAuthSuccess();
            return;
        }

        // GBPE profiles may resolve after OSS mounts; retry when auth becomes ready.
        this.gbpeAuthPoll = setInterval(() => {
            if (window.gbpe?.auth?.currentAuthState === 1 && window.gbpe?.auth?.idToken) {
                clearInterval(this.gbpeAuthPoll);
                this.handleGbpeAuthSuccess();
            }
        }, 250);

        this.gbpeAuthTimeout = setTimeout(() => {
            clearInterval(this.gbpeAuthPoll);
            if (window.gbpe?.auth?.currentAuthState !== 1) {
                history.push(vehicle);
                checkSession(false);
            }
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.gbpeAuthPoll);
        clearTimeout(this.gbpeAuthTimeout);
    }

    cookieCheck() {
        let { setSessionActive, checkSession } = this.props;
        const url = getApiBaseUrl(process.env.REACT_APP_IAM_BASE_URL) + cookieConst;

        const headers = {};

        checkSession(true);

        axios
            .post(url, {}, { headers })
            .then((res) => {
                loginGPMS(res.data.accessToken, (vehicles) => {
                    setSessionActive(true);
                    checkSession(false);
                    this.routeAfterProfile(vehicles);
                });
            })
            .catch(() => {
                setSessionActive(false);
                checkSession(false);
                this.props.history.push(signIn);
            });
    }

    render() {
        let { translations, checkSessionFlag } = this.props;

        return (
            <div>
                {!checkSessionFlag ? (
                    <div className="landing-container">
                        <h2>{translations.SIGN_IN}</h2>
                        <div className="headline-border" />
                        <div className="landing-body">
                            <p className="landing-prompt">{translations.START_BOOKING}</p>
                            <button id="btnSignIn" className="button primary-button sign-in" onClick={this.cookieCheck}>
                                {translations.SIGN_IN}
                            </button>
                            <Link id="btnContinueSignInPage" className="button secondary-button continue" to={vehicle}>
                                {translations.CONTINUE_GUEST}
                            </Link>
                        </div>
                        <div className="landing-subtitle">{translations.GM_OSS}</div>
                        <div
                            className="helpful-links desc"
                            dangerouslySetInnerHTML={{
                                __html: translations.SIGN_IN_TEXT,
                            }}
                        />
                    </div>
                ) : (
                    <div className="loading">
                        <CircularProgress />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    translations: state.countryOptionsReducer.translations,
    checkSessionFlag: state.myGarageReducer.checkSessionFlag,
});

const mapDispatchToProps = {
    setSessionActive,
    checkSession,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingGbpe));
